<template>
    <div class="container-fluid bg-driver-portal m-0 p-0 animated fadeIn slow" style="height: 100vh;">
        <div class="lime-bar-footer fixed-bottom"></div>
        <div v-if="userRole">
            <div v-if="userRole === 'admin'" class="container px-0"
                 style="position: relative;">
                <TheHeader/>
                <div class="d-flex flex-column">
                    <div class="align-self-center my-auto">
                        <div class="ml--5 mt-0 mt-md-5 pt-5">
                            <div class="ml--5 title font-italic font-weight-bold text-uppercase font-xxl">
                                admin portal
                            </div>
                            <div class="lime-bar-diag">
                                <img src="../assets/img/Asset_3.png" alt="" class="">
                            </div>
                            <div class="text-uppercase font-italic sub-title font-sm">
                                superusers live here.
                            </div>
                        </div>
                        <!--<div class="container">User:: {{JSON.stringify(user)}}</div>-->
                        <div class="d-flex justify-content-center mt-2 pt-5">
                            <div class="card text-left mx-2 mb-5 shadow">

                                <div class="card-body bg-lime pb-0">
                                    <b-form-group label="Select Type">
                                        <b-form-radio value="create" v-model="createOrUpdate"
                                                      name="role-radios">
                                            Create New Account
                                        </b-form-radio>
                                        <b-form-radio value="update" v-model="createOrUpdate"
                                                      name="role-radios" class="mt-2">
                                            Update Existing Account
                                        </b-form-radio>
                                    </b-form-group>
                                </div>


                                <!--create new user card-->
                                <div v-if="createOrUpdate === 'create'">

                                    <div class="card-header bg-dark text-light text-uppercase">
                                        create new user
                                    </div>

                                    <div class="card-body">
                                        <div class="card-title">Enter the email address for the account you wish to
                                            create
                                        </div>
                                        <form class="card-body">
                                            <b-form-group>
                                                <input id="newEmail"
                                                       type="email"
                                                       v-model="userDetails.email"
                                                       placeholder="enter new email"
                                                       class="shadow w-100 px-3 px-3">
                                                <!--<label for="email" class="font-sm">Add ADMIN Role to account</label>-->
                                            </b-form-group>
                                            <b-form-group>
                                                <input v-model="userDetails.name"
                                                       type="text"
                                                       placeholder="enter full name"
                                                       class="shadow w-100 px-3 px-3">
                                            </b-form-group>
                                            <b-form-group>
                                                <input v-model="userDetails.country"
                                                       type="text"
                                                       placeholder="enter country"
                                                       class="shadow w-100 px-3 px-3">
                                            </b-form-group>

                                            <h4><span class="badge badge-secondary">temp password: rufus7</span></h4>
                                            <div>
                                                <div class="mt-5">
                                                    <b-form-group label="Select Role">
                                                        <b-form-radio value="admin" v-model="roleSelected"
                                                                      name="role-radios">
                                                            Admin
                                                        </b-form-radio>
                                                        <b-form-radio value="driver" v-model="roleSelected"
                                                                      name="role-radios">
                                                            Driver
                                                        </b-form-radio>
                                                        <b-form-radio value="industry" v-model="roleSelected"
                                                                      name="role-radios">
                                                            Industry
                                                        </b-form-radio>
                                                        <b-form-radio value="public" v-model="roleSelected"
                                                                      name="role-radios">
                                                            Public
                                                        </b-form-radio>
                                                    </b-form-group>
                                                </div>

                                                <div v-if="errorMessage" class="alert alert-danger">
                                                    <div class="font-md">
                                                        {{errorCode}}
                                                    </div>
                                                    <div class="font-sm">
                                                        {{errorMessage}}
                                                    </div>
                                                </div>

                                                <div v-if="successMessage" class="alert alert-success">
                                                    {{successMessage}}
                                                </div>

                                                <button class="btn btn-outline-dark mt-3 text-uppercase"
                                                        @click.prevent="createAccount"
                                                        :disabled="!userDetails.email || !roleSelected">
                                                    create <span class="" v-if="email">{{email}}</span> <span
                                                        v-if="roleSelected"> as:
                                                <strong v-if="roleSelected === 'admin'"
                                                        class="text-danger border border-danger rounded px-1">{{roleSelected}}</strong>

                                                <strong v-if="roleSelected === 'driver'"
                                                        class="text-primary border border-primary rounded px-1">{{roleSelected}}</strong>

                                                <strong v-if="roleSelected === 'industry'"
                                                        class="text-info border border-info rounded px-1">{{roleSelected}}</strong>

                                                <strong v-if="roleSelected === 'public'"
                                                        class="text-warning border border-warning rounded px-1">{{roleSelected}}</strong>
                                            </span>
                                                </button>
                                            </div>
                                        </form>
                                    </div>

                                </div>

                                <!--update existing user card-->
                                <div v-if="createOrUpdate === 'update'">
                                    <div class="card-header bg-dark text-light text-uppercase">
                                        update user role
                                    </div>

                                    <div class="card-body">
                                        <div class="card-title">Enter the email address of the account you wish to
                                            update
                                        </div>
                                        <form class="card-body">
                                            <b-form-group>
                                                <input id="email"
                                                       type="email"
                                                       v-model="email"
                                                       placeholder="enter account email"
                                                       class="shadow w-100 px-3">
                                                <!--<label for="email" class="font-sm">Add ADMIN Role to account</label>-->
                                            </b-form-group>
                                            <div>
                                                <div class="mt-5">
                                                    <b-form-group label="Select Role">
                                                        <b-form-radio value="admin" v-model="roleSelected"
                                                                      name="role-radios">
                                                            Admin
                                                        </b-form-radio>
                                                        <b-form-radio value="driver" v-model="roleSelected"
                                                                      name="role-radios">
                                                            Driver
                                                        </b-form-radio>
                                                        <b-form-radio value="industry" v-model="roleSelected"
                                                                      name="role-radios">
                                                            Industry
                                                        </b-form-radio>
                                                        <b-form-radio value="public" v-model="roleSelected"
                                                                      name="role-radios">
                                                            Public
                                                        </b-form-radio>
                                                    </b-form-group>
                                                </div>

                                                <div v-if="errorMessage" class="alert alert-danger">
                                                    <div class="font-md">
                                                        {{errorCode}}
                                                    </div>
                                                    <div class="font-sm">
                                                        {{errorMessage}}
                                                    </div>
                                                </div>

                                                <div v-if="successMessage" class="alert alert-success">
                                                    {{successMessage}}
                                                </div>

                                                <button class="btn btn-outline-dark mt-3 text-uppercase"
                                                        @click.prevent="updateRole"
                                                        :disabled="!email || !roleSelected">
                                                    update <span class="" v-if="email">{{email}}</span> <span
                                                        v-if="roleSelected"> to:
                                                <strong v-if="roleSelected === 'admin'"
                                                        class="text-danger border border-danger rounded px-1">{{roleSelected}}</strong>

                                                <strong v-if="roleSelected === 'driver'"
                                                        class="text-primary border border-primary rounded px-1">{{roleSelected}}</strong>

                                                <strong v-if="roleSelected === 'industry'"
                                                        class="text-info border border-info rounded px-1">{{roleSelected}}</strong>

                                                <strong v-if="roleSelected === 'public'"
                                                        class="text-warning border border-warning rounded px-1">{{roleSelected}}</strong>
                                            </span>
                                                </button>
                                            </div>
                                        </form>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div v-else class="font-xl font-weight-semi-bold">
                <div class="container mb-5 pb-5">
                    <TheHeader/>
                </div>
                <div style="margin-top: 200px;">
                    Sorry, you don't have the correct permissions to access this
                    page...
                </div>
            </div>
        </div>

        <div v-else class="font-xl font-weight-semi-bold container" style="margin-top: 200px;">Sorry, you don't have the
            correct permissions to access this page...
        </div>
    </div>
</template>

<script>
    import TheHeader from '../components/TheHeader'

    export default {
        name      : "adminPortal",
        components: {
            TheHeader
        },
        data () {
            return {
                userDetails   : {
                    email   : '',
                    password: 'rufus7',
                    country : null,
                    name    : null,
                },
                email         : '',
                roleSelected  : null,
                successCode   : null,
                successMessage: null,
                errorMessage  : null,
                createOrUpdate: null,
                userType      : null
            }
        },
        computed  : {
            userRole () {
                return this.$store.getters.getUserRole
            }
        },
        methods   : {
            handleMessages (result) {
                let self            = this
                self.errorMessage   = null
                self.errorCode      = null
                self.successMessage = null
                // console.log(JSON.stringify(result));
                // console.log(result);
                if (result.data.message) {
                    let successMsg      = result.data.message
                    self.successMessage = successMsg
                }

                if (result.data.errorInfo.code) {
                    let errCode    = result.data.errorInfo.code
                    self.errorCode = errCode
                }

                if (result.data.errorInfo.message) {
                    let errMessage    = result.data.errorInfo.message
                    self.errorMessage = errMessage
                }

                console.log('success message??:: ' + successMsg)

                if (result.data.message) {
                    self.successMessage = successMsg
                }
            },
            updateRole () {
                let role = this.roleSelected
                if (role === 'admin') {
                    this.addAdmin()
                } else if (role === 'driver') {
                    this.addDriver()
                } else if (role === 'industry') {
                    this.addIndustry()
                } else {
                    this.addPublic()
                }
            },
            createAccount () {
                let userDetails = this.userDetails
                let self        = this

                this.$store.dispatch('register', userDetails)
                    .then(() => {
                        self.email = self.userDetails.email
                        self.updateRole()
                    })
                    .catch((error) => {
                        console.log(error)
                        // self.$router.push({path: '/'})
                    })
            },
            addDriver () {
                let self          = this
                let email         = this.email
                let AddDriverRole = functions.httpsCallable('addDriverRole')
                AddDriverRole({email: email})
                    .then(result => {
                        self.handleMessages(result)
                    })
                    .catch(err => {
                        if (err) {
                            console.log(err.message)
                        }
                    })
            },
            addAdmin () {
                let self         = this
                let email        = this.email
                let AddAdminRole = functions.httpsCallable('addAdminRole')
                AddAdminRole({email: email})
                    .then(result => {
                        self.handleMessages(result)
                    })
                    .catch(err => {
                        if (err) {
                            console.log(err.message)
                        }
                    })
            },
            addIndustry () {
                let self            = this
                let email           = this.email
                let AddIndustryRole = functions.httpsCallable('AddIndustryRole')
                AddIndustryRole({email: email})
                    .then(result => {
                        self.handleMessages(result)
                    })
                    .catch(err => {
                        if (err) {
                            console.log(err.message)
                        }
                    })
            },
            addPublic () {
                let self          = this
                let email         = this.email
                let AddPublicRole = functions.httpsCallable('addPublicRole')
                AddPublicRole({email: email})
                    .then(result => {
                        self.handleMessages(result)
                    })
                    .catch(err => {
                        if (err) {
                            console.log(err.message)
                        }
                    })
            }
        },
        watch     : {
            userRole (val) {
                if (val !== 'admin') {
                    this.$router.push({path: '/toc'})
                }
            }
        },
        created () {
            this.$store.dispatch('getUserAccount')
        }
    }
</script>

<style scoped lang="scss">
    @import '../assets/css/_vars.scss';

    .bg-driver-portal {
        background-image: url(../assets/img/eligibility.png);
        background-position: center; /* Center the image */
        background-repeat: no-repeat; /* Do not repeat the image */
        background-size: cover; /* Resize the background image to cover the entire container */
        background-attachment: fixed;
        overflow-x: auto;
    }

    input {
        background: white;
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: 1px solid $gray;
    }

    label {
        color: $gray;
    }

    @media all and (max-width: 576px) {

        .title {
            margin-left: -20px;
        }

        .sub-title {
            margin-left: 170px;
        }
    }

    @media all and (min-width: 577px) and (max-width: 767px) {

        .title {
            margin-left: -50px;
        }

        .sub-title {
            margin-left: 210px;
        }
    }

    @media all and (min-width: 768px) and (max-width: 991px) {

        .title {
            margin-left: -70px;
        }

        .sub-title {
            margin-left: 230px;
        }

    }

    @media all and (min-width: 992px) and (max-width: 1199px) {
        .title {
            margin-left: -50px;
        }

        .sub-title {
            margin-left: 150px;
        }
    }

    @media all and (min-width: 1200px) {

        .sub-title {
            margin-right: -200px;
        }

    }


</style>
